/* eslint-disable @typescript-eslint/no-extraneous-class */
import updateLocale from 'dayjs/plugin/updateLocale';
import localeData from 'dayjs/plugin/localeData';
import dayjs from 'dayjs';
import { IDatePartModel } from './models/date-part.model';
import { IDatePickerModel } from './models/date-picker.model';
import 'dayjs/locale/it';

export class DateHelper {
  public static setLocale(language: string): void {
    dayjs.extend(localeData);
    dayjs.locale(language);

    dayjs.extend(updateLocale);
    dayjs.updateLocale('it', {
      weekdays: ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'],
      months: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
    });
  }

  // method to get years in the range the user gives to the datepicker with props to and from
  public static getYearDataSource(from?: number, to?: number): IDatePartModel[] {
    const defaultFrom: number = new Date().getFullYear() - 10;
    const defaultTo: number = new Date().getFullYear();
    const _from = from || defaultFrom;
    const _to = to || defaultTo;

    const range: number[] = Array.from(Array(_to - _from + 1).keys())
      .reverse()
      .map(val => _from + val);
    return range.map(item => {
      return { name: item.toString(), value: item };
    });
  }

  // method to return weekdays names in this case we are using italian as language

  public static getWeekDaysNames(language: string): string[] {
    this.setLocale(language);
    return dayjs.weekdays().map(w => `${w[0]}${w[1]}`);
  }

  public static getMonthDataSource(language: string): IDatePartModel[] {
    this.setLocale(language);
    return dayjs.months().map((m: string, index: number) => {
      return { name: m, value: index };
    });
  }

  public static getDaysDataSource(date: Date): IDatePartModel[] {
    const dates: Date[] = [];
    let start = dayjs(date).startOf('month');
    dates.push(start.clone().toDate());
    start = start.clone().add(1, 'days');
    while (start.toDate().getDate() > 1) {
      dates.push(start.clone().toDate());
      start = start.add(1, 'days');
    }
    return dates.map((date: Date) => {
      return { name: date.getDate().toString(), value: date.getDate() };
    });
  }

  // method to get days in a selected month

  public static getMonthDates(date: any, language: string): Array<IDatePickerModel> {
    const mDate = dayjs(date);
    const sm = dayjs(date).startOf('month');
    let startDate;
    let endDate;
    if (language === 'it') {
      startDate = sm.day(-6); // posizione da cui iniziare a mostrare i giorni
      const em = dayjs(date).endOf('month');
      endDate = em.day(7);
    } else {
      startDate = sm.day(-7); // posizione da cui iniziare a mostrare i giorni
      const em = dayjs(date).endOf('month');
      endDate = em.day(7);
    }
    const dates = this.getDateRange(startDate.toDate(), endDate.toDate());
    return dates.map<IDatePickerModel>(x => {
      const m = dayjs(x);
      return {
        date: x,
        isCurrentMonth: this.isSameMonth(x, mDate.toDate()),
        text: m.format('D'),
      };
    });
  }

  // method to get days in the week range
  public static getDaysGroupedByWeeks(days: IDatePickerModel[]) {
    const DAYS_PER_WEEK = 7;
    return [...Array(Math.ceil(days.length / DAYS_PER_WEEK)).keys()]
      .map(ind => days.slice(ind * DAYS_PER_WEEK, DAYS_PER_WEEK * (ind + 1)))
      .filter(i => i.findIndex(el => el.isCurrentMonth) > -1);
  }

  public static getDay(interval: number, date: Date, datePart: string): Date {
    return dayjs(date)
      .add(interval, datePart as any)
      .toDate();
  }

  public static areDatesEqual(date1: Date, date2: Date): boolean {
    return dayjs(date1).format('DDMMYYYY') === dayjs(date2).format('DDMMYYYY');
  }

  public static isSameMonth(date1: Date, date2: Date): boolean {
    return dayjs(date1).format('MMYYYY') === dayjs(date2).format('MMYYYY');
  }

  private static getDateRange(startDate: Date, endDate: Date): Array<Date> {
    // no
    const dates: Array<Date> = [];

    const currDate = dayjs(startDate).startOf('day');
    const lastDate = dayjs(endDate).startOf('day');
    dates.push(currDate.clone().toDate());

    while (currDate.add(1, 'days').diff(lastDate) <= 0) {
      dates.push(currDate.clone().toDate());
    }

    return dates;
  }
}
